import { MutationCache, QueryCache, QueryClient } from '@tanstack/vue-query';
import { ValidationError } from 'myzod';
import { ZodError } from 'zod';
import { hooks } from '#infrastructure/hook';
import { HTTPError } from '#infrastructure/http';
import { HttpError } from '#kernel/httpClient';

async function onError(error: any) {
	await hooks.callHook('query-client::error', error);
}

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: (failureCount, error: any) => {
				if (error instanceof ZodError || error instanceof ValidationError) {
					return false;
				}

				if (error instanceof HTTPError || error instanceof HttpError) {
					const status = error instanceof HTTPError ? error.response.status : error.code;

					if ([400, 401, 404].includes(status)) {
						return false;
					}

					if ([500, 503, 504].includes(status) && failureCount <= 5) {
						return true;
					}
				}

				return false;
			},
			structuralSharing: false,
		},
	},

	mutationCache: new MutationCache({
		onError,
	}),

	queryCache: new QueryCache({
		onError,
	}),
});

// broadcastQueryClient({
// 	// @ts-expect-error - This is a known issue with the library
// 	queryClient,
// 	broadcastChannel: 'vis-web-manager',
// });
